import { call, put, takeLatest } from "@redux-saga/core/effects";
import { SearchHistoryConstant } from "./SearchHistoryConstant";
import { SearchHistoryApiData } from "./SearchHistoryApi";
import { SearchHistoryParser } from "./SearchHistoryParser";
// import { ConfigTableParser } from "./ConfigParser";
function* getSearchHistoryData({ payload }) {
  let {from_date,to_date, search_term, page, limit,sorting} = payload;

  try {
    yield put({ type: SearchHistoryConstant.SEARCHHISTORY_REQUEST });
    const res = yield call(SearchHistoryApiData.getSearchHistoryData,{
      to_date,
      from_date,
      search_term,
      page,
      limit,
      sorting
    });
    const payload = SearchHistoryParser.getSearchHistoryParser(res);
    yield put({
      type: SearchHistoryConstant.SEARCHHISTORY_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: SearchHistoryConstant.SEARCHHISTORY_RESPONSE,
      payload: [],
    });
  }
}


export function* SearchHistoryDataSaga() {
  yield takeLatest(SearchHistoryConstant.SEARCHHISTORY_SAGA, getSearchHistoryData);
}
